//export const API_URL = 'https://api.t1.dashur.io/v1/lobby-api';
export const API_URL = 'https://lobby-api.gameatrium.com/v1/lobby-api';
export const DEFAULT_LOCALE = 'en';
export const CHECK_NEW_WINNER_INTERVAL = 60000; // 1 minute in ms
